import { render, staticRenderFns } from "./ShotHeaderCp.vue?vue&type=template&id=6c7dfcb6&scoped=true&"
import script from "./ShotHeaderCp.vue?vue&type=script&lang=js&"
export * from "./ShotHeaderCp.vue?vue&type=script&lang=js&"
import style0 from "./ShotHeaderCp.vue?vue&type=style&index=0&id=6c7dfcb6&prod&lang=scss&scoped=true&"
import style1 from "./ShotHeaderCp.vue?vue&type=style&index=1&id=6c7dfcb6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7dfcb6",
  null
  
)

export default component.exports